import * as types from '../actions/actionTypes';
import initialState from './initialState';

export default function authReducer(state = initialState.me, action) {
    switch (action.type) {
        case types.AUTH_LOGIN_SUCCESS:
            return action.me;

      case types.AUTH_GET_CURRENT_USER_SUCCESS:
            return Object.assign({},action.user);

        case types.AUTH_LOGIN_FAILURE:
            return action.error;

        case types.USER_LOGOUT_SUCCESS:
            return null;

        default:
            return state;
    }
}


/** WEBPACK FOOTER **
 ** ./src/reducers/authReducer.js
 **/